import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Breadcrumb, Row, Button, Card, Form, Modal, Skeleton } from 'antd';
import { Link } from 'react-router-dom';
import { permissionService } from 'shared/services';
import OneRowData from 'components/OneRowData';
import { formatDateTime } from 'shared/utils/StringUtil';

import allBillerRoute from 'modules/AllBillers/route';
import FormDelete from 'modules/AllBillers/components/FormDelete/FormDelete.component';

import BillerOfForm from './BillerOfForm/BillerOfForm.component';

import CardComponent from './ComponentCard/ComponentCard.form';

import FormData from '../FormList/FormData.form';

import './FormDetail.style.less';

import text from './FormDetail.page.translation';

const CardComponentForm = Form.create()(CardComponent);
const FormDataUpdate = Form.create()(FormData);

const { checkPermission } = permissionService;
export default class FormDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formModal: false,
      isUpdate: false,
      deleteForm: false,
      components: {},
    };
  }

  componentDidMount() {
    const formId = this.props.match.params.id;
    this._getFormDetail(formId);
    this.props.checkFormToDelete(formId);
  }

  _parseComponent = form => JSON.parse(_.get(form, 'components', '{}') || '{}');

  _onGetFormSuccess = form => {
    const componentForm = this._parseComponent(form);
    this.setState({
      formModal: false,
      deleteForm: false,
      components: {
        en: {
          title: _.get(componentForm, 'en.title'),
          btnText: _.get(componentForm, 'en.btnText'),
          paymentTitle: _.get(componentForm, 'en.paymentTitle'),
          paymentBtnText: _.get(componentForm, 'en.paymentBtnText'),
        },
        id: {
          title: _.get(componentForm, 'id.title'),
          btnText: _.get(componentForm, 'id.btnText'),
          paymentTitle: _.get(componentForm, 'id.paymentTitle'),
          paymentBtnText: _.get(componentForm, 'id.paymentBtnText'),
        },
        components: _.get(componentForm, 'components', []),
        paymentComponents: _.get(componentForm, 'paymentComponents', []),
        sectionHeader: _.get(componentForm, 'sectionHeader', 'banner'),
        validationPrefix: _.get(componentForm, 'validationPrefix', 'dynamic'),
        showPrefix: _.get(componentForm, 'showPrefix', 'no'),
        selectedChanel: _.get(componentForm, 'selectedChanel', 'switching'),
      },
    });
  };

  _getFormDetail = id => {
    this.props.getForm(id, this._onGetFormSuccess);
  };

  _renderTag = () => {
    const { formDetail } = this.props;
    const tagName = _.get(formDetail, 'tag_name');
    if (!tagName) {
      return (
        <div className="tag">
          <span>-</span>
        </div>
      );
    }
    return (
      <div className="tag">
        <span>{tagName}</span>
        <div className={`tag-color ${tagName.toLowerCase()}`} />
      </div>
    );
  };

  _renderDetailLeft = () => {
    const {
      intl: { formatMessage },
      formDetail,
      loading,
    } = this.props;
    return (
      <Skeleton
        loading={loading}
        active
        paragraph={{ rows: 3, width: ['100%', '100%'] }}
        title={false}
      >
        <OneRowData
          data={{
            label: formatMessage(text.detail.id),
            value: _.get(formDetail, 'public_id'),
          }}
        />
        <OneRowData
          data={{
            label: formatMessage(text.detail.name),
            value: _.get(formDetail, 'name'),
          }}
        />
        <OneRowData
          data={{
            label: formatMessage(text.detail.desc),
            value: _.get(formDetail, 'description'),
          }}
        />
      </Skeleton>
    );
  };

  _renderDetailRight = () => {
    const {
      intl: { formatMessage },
      formDetail,
      loading,
    } = this.props;
    return (
      <Skeleton
        loading={loading}
        active
        paragraph={{ rows: 3, width: ['100%', '100%'] }}
        title={false}
      >
        <OneRowData
          data={{
            label: formatMessage(text.detail.tag),
            node: this._renderTag,
          }}
        />
        <OneRowData
          data={{
            label: formatMessage(text.detail.created),
            value: formatDateTime(_.get(formDetail, 'created_at')),
          }}
        />
        <OneRowData
          data={{
            label: formatMessage(text.detail.updated),
            value: formatDateTime(_.get(formDetail, 'updated_at')),
          }}
        />
      </Skeleton>
    );
  };

  _renderBreadcrumb = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">{formatMessage(text.breadcrumb.home)}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={allBillerRoute.FORM_BUILDERS}>
              {formatMessage(text.breadcrumb.form)}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{formatMessage(text.detail.title)}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
    );
  };

  renderModalTitle = title => (
    <Row className="modal-title-form-builder">{title}</Row>
  );

  _handleUpdateForm = value => {
    const {
      formDetail: { id },
      updateForm,
    } = this.props;
    updateForm(id, value, this._getFormDetail);
  };

  _renderModalUpdateDetail = () => {
    const { formModal } = this.state;
    return (
      <Modal
        title={this.renderModalTitle('Edit Form')}
        visible={formModal}
        footer={null}
        destroyOnClose
        onCancel={this._toggleUpdateForm(false)}
        className="modal-create"
      >
        <FormDataUpdate
          onSubmit={this._handleUpdateForm}
          loading={this.props.loading}
          cancelFunction={this._toggleUpdateForm(false)}
          formValue={this.props.formDetail}
          intl={this.props.intl}
        />
      </Modal>
    );
  };

  _onDeleteFormSuccess = () => {
    this.props.history.goBack();
  };

  _handleDeleteForm = () => {
    const { deleteForm, formDetail } = this.props;
    deleteForm(formDetail.id, this._onDeleteFormSuccess);
  };

  _renderModalDeleteDetail = () => {
    const { deleteForm } = this.state;
    const { intl, formDetail, linked, loading } = this.props;
    return (
      <FormDelete
        selectedForm={formDetail}
        isDelete={deleteForm}
        linked={linked}
        intl={intl}
        loading={loading}
        onCloseModal={this._toggleDiscardForm(false)}
        handleDelete={this._handleDeleteForm}
      />
    );
  };

  _toggleUpdateForm = isShowModal => () => {
    this.setState({ formModal: isShowModal });
  };

  _toggleDiscardForm = isShowModal => () => {
    this.setState({ deleteForm: isShowModal });
  };

  _renderDetailCard = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div className="white-box-wrapper">
        <span className="title">{formatMessage(text.detail.title)}</span>
        <Card bordered={false}>
          <Row type="flex">
            <Card.Grid className="card-grid-style minH210">
              {this._renderDetailLeft()}
            </Card.Grid>
            <Card.Grid className="card-grid-style minH210">
              {this._renderDetailRight()}
            </Card.Grid>
          </Row>
        </Card>
        <div className="footer-card">
          {checkPermission('Form Builder:update', true) && (
            <Button type="primary" onClick={this._toggleUpdateForm(true)}>
              {formatMessage(text.btn.edit)}
            </Button>
          )}
          {checkPermission('Form Builder:delete', true) && (
            <Button
              type="danger"
              className="ml-15"
              onClick={this._toggleDiscardForm(true)}
            >
              {formatMessage(text.btn.discard)}
            </Button>
          )}
        </div>
        {this._renderModalUpdateDetail()}
        {this._renderModalDeleteDetail()}
      </div>
    );
  };

  _onEditComponentCard = () => {
    this.setState({ isUpdate: true });
  };

  _onResetComponentCard = () => {
    this.setState({ isUpdate: false });
  };

  _onSaveComponentCard = value => {
    const {
      formDetail: { id },
      updateForm,
    } = this.props;

    updateForm(id, { components: value }, this._getFormDetail);

    this.setState({ components: value, isUpdate: false });
  };

  _renderComponentCard = () => (
    <div className="white-box-wrapper scaled" style={{ paddingBottom: '0px' }}>
      <CardComponentForm
        intl={this.props.intl}
        isUpdate={this.state.isUpdate}
        loading={this.props.loading}
        formName={_.get(this.props, 'formDetail.name')}
        currentValue={this.state.components}
        defaultComponent={this._parseComponent(_.get(this.props, 'formDetail'))}
        onEdit={this._onEditComponentCard}
        onReset={this._onResetComponentCard}
        onSave={this._onSaveComponentCard}
      />
    </div>
  );

  _renderConnectedCard = () => {
    const {
      intl,
      history,
      billerOfForm,
      getBillerOfForm,
      loading,
      formDetail: { id },
    } = this.props;
    return (
      <BillerOfForm
        intl={intl}
        history={history}
        formId={id}
        billerOfForm={billerOfForm}
        loading={loading}
        getBillerOfForm={getBillerOfForm}
      />
    );
  };

  render() {
    return (
      <div className="main-content">
        {this._renderBreadcrumb()}
        {this._renderDetailCard()}
        {this._renderComponentCard()}
        {this._renderConnectedCard()}
      </div>
    );
  }
}

FormDetail.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.object,
  match: PropTypes.object,
  formDetail: PropTypes.object,
  billerOfForm: PropTypes.array,
  getForm: PropTypes.func,
  linked: PropTypes.bool,
  checkFormToDelete: PropTypes.func,
  updateForm: PropTypes.func,
  getBillerOfForm: PropTypes.func,
  deleteForm: PropTypes.func,
  loading: PropTypes.bool,
};
